/**
 * Foundation/Anagrafica — iscrizioni agli istituti (INPS, INAIL, Cassa Edile, ...).
 * Terminologia degli enti: per INAIL Codice Ditta, PAT e Codice PIN (per singola posizione).
 */
export const INAIL_PIN_MAX_DIGITS = 6;

export const registrationFieldsFor = (kind) => ({
  numberLabel: kind === "inail" ? "Codice Ditta" : "Numero iscrizione",
  showPat: kind === "inail",
  showPin: kind === "inail",
});

export const sanitizeInailPin = (value) => String(value || "").replace(/\D/g, "").slice(0, INAIL_PIN_MAX_DIGITS);

export function validateInailPin(value) {
  const v = (value || "").trim();
  if (!v) return null;
  return /^\d{1,6}$/.test(v) ? null : "Codice PIN non valido (massimo 6 cifre)";
}
